<div class="message-stack">
  @for (m of list(); track m.id) {
    <div class="message-container" [ngClass]="alertClass(m.type)" role="status" aria-live="polite">
      <div class="message-icon" aria-hidden="true">
        @switch (m.type) {
          @case ('success') {
            <i class="fa-solid fa-circle-check"></i>
          }
          @case ('info') {
            <i class="fa-solid fa-circle-info"></i>
          }
          @case ('warning') {
            <i class="fa-solid fa-triangle-exclamation"></i>
          }
          @case ('danger') {
            <i class="fa-solid fa-circle-exclamation"></i>
          }
        }
      </div>

      <div class="message-content">
        {{ m.content }}
      </div>

      @if (m.dismissible) {
        <button type="button" class="message-close" aria-label="Close" (click)="close(m.id)">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
</div>